import { render, staticRenderFns } from "./ProductCustomisationImageUpload.vue?vue&type=template&id=3b5b8cbc&"
import script from "./ProductCustomisationImageUpload.vue?vue&type=script&lang=js&"
export * from "./ProductCustomisationImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomisationImageUpload.vue?vue&type=style&index=0&id=3b5b8cbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports